/**
 * 后端约定的错误码
 *
 * @file code-map.js
 * @author yangwei(yangwei14@baidu.com)
 */

export default {
    SUCCESS: {
        code: 0
    },
    NOT_LOGIN: {
        code: 5001,
        message: '您暂未登录'
    },
    INVALID_PARAM: {
        code: 422,
        message: '参数错误！'
    },
    USER_MEETING_COUNT_EXCEED_QUOTA: {
        code: 5002,
        message: '会议数量超限'
    },
    SERVICE_ERROR: {
        code: 6001,
        message: '服务错误'
    },
    SERVICE_BUSY: {
        code: 6002,
        message: '服务繁忙'
    },
    UNKNOWN: {
        code: 9001,
        message: '未知错误'
    }
};
